module.exports = __webpack_public_path__ + "static/img/logo10.f226d6fb.png";